$(document).ready(function () {
  $(window).resize(function () {
    var width = window.innerWidth;
    if (width < 750) {
      var titles = $(".footer-title").get();
      for (var i = 0; i < titles.length; i++) {
        $(titles[i]).replaceWith(
          $(
            '<button class="btn-footer-title footer-title">' +
              titles[i].innerHTML +
              "</button>"
          )
        );
      }
      var links_to_title = $(".site-footer__linklist").get();
      links_to_title.map((link) => {
        $(link).addClass("mobile-footer-link-hidden");
      });

      const titleButtons = document.getElementsByClassName("btn-footer-title ");
      for (var i = 0; i < titleButtons.length; i++) {
        const linkList = titleButtons[i].nextElementSibling;

        titleButtons[i].addEventListener("click", () => {
          console.log(linkList);
          if (linkList.classList.contains("mobile-footer-link-hidden")) {
            linkList.classList.remove("mobile-footer-link-hidden");
            linkList.classList.add("mobile-footer-link-visible");
          } else {
            linkList.classList.remove("mobile-footer-link-visible");
            linkList.classList.add("mobile-footer-link-hidden");
          }
        });
      }
    } else {
      var titles = $(".footer-title").get();
      for (var i = 0; i < titles.length; i++) {
        $(titles[i]).replaceWith(
          $(
            '<p class="h4 footer-title" id="footer-title">' +
              titles[i].innerHTML +
              "</p>"
          )
        );
      }
      var links_to_title = $(".site-footer__linklist").get();
      for (var i = 0; i < links_to_title.length; i++) {
        $(links_to_title[i]).css({ "max-height": "500px", height: "auto" });
      }
    }
  });
});
